import React from "react";

const ApplicationBtnCenterApplied: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="76.851"
      height="76.851"
      viewBox="0 0 76.851 76.851"
    >
      <g
        id="グループ_359"
        data-name="グループ 359"
        transform="translate(-1131.652 -247.028)"
      >
        <g id="グループ_360" data-name="グループ 360">
          <circle
            id="楕円形_6"
            data-name="楕円形 6"
            cx="38.425"
            cy="38.425"
            r="38.425"
            transform="translate(1131.652 247.028)"
          />
          <g
            id="グループ_353"
            data-name="グループ 353"
            transform="translate(44.189 -305.917)"
            opacity="0.24"
          >
            <g
              id="グループ_354"
              data-name="グループ 354"
              transform="translate(1108.463 566.945)"
            >
              <g id="グループ_353-2" data-name="グループ 353">
                <path
                  id="パス_1979"
                  data-name="パス 1979"
                  d="M1154.178,616.747v.007l-19.422,11.209V619.17l-3.869,2.235-.971-1.676,4.84-2.794,2.235-1.292,7.878-4.546.964,1.676-8.841,5.105v6.558l14.952-8.632V592.15l-.971-1.676.971-.559,2.235-1.292Z"
                  transform="translate(-1120.6 -579.209)"
                  fill="#fff"
                />
                <path
                  id="パス_1980"
                  data-name="パス 1980"
                  d="M1173.363,592.885l.97,1.676-3.869,2.235-.971-1.676Z"
                  transform="translate(-1142.99 -581.62)"
                  fill="#fff"
                />
                <path
                  id="パス_1981"
                  data-name="パス 1981"
                  d="M1154.379,588.252l-.971.566v17.089l-1.271.733-.964-1.676V590.11l-10.113,5.839v-2.242l10.113-5.838v-6.558l-.971-1.676.971-.559,2.235-1.292v8.793Z"
                  transform="translate(-1126.905 -573.077)"
                  fill="#fff"
                />
                <path
                  id="パス_1982"
                  data-name="パス 1982"
                  d="M1157.072,582.045l.971,1.676-3.869,2.235-.971-1.676Z"
                  transform="translate(-1133.774 -575.488)"
                  fill="#fff"
                />
                <path
                  id="パス_1983"
                  data-name="パス 1983"
                  d="M1135.844,575.737l.971,1.676-.971.559-2.242,1.292-7.871,4.546v14.862l10.113-5.839v2.235l-10.113,5.839v6.558l.971,1.676-.971.559-2.242,1.292V602.2l-.971-1.676.971-.566V582.868l10.113-5.838v-6.558l-.964-1.676,3.205-1.851v8.793Z"
                  transform="translate(-1116.415 -566.945)"
                  fill="#fff"
                />
                <path
                  id="パス_1984"
                  data-name="パス 1984"
                  d="M1124.687,571.206l.964,1.676-14.953,8.632v23.654l.971,1.676-.971.559-2.235,1.292V580.572Z"
                  transform="translate(-1108.463 -569.356)"
                  fill="#fff"
                />
                <path
                  id="パス_1985"
                  data-name="パス 1985"
                  d="M1117.478,644.266l.971,1.676-3.869,2.235-.971-1.676Z"
                  transform="translate(-1111.375 -610.688)"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
        </g>
        <text
          id="応募_済み"
          data-name="応募
済み"
          transform="translate(1169.652 282.028)"
          fill="#c2c2c2"
          fontSize="21"
          fontFamily="mplus-1p-regular, 'M\+ \31 p'"
        >
          <tspan x="-21" y="0">
            応募
          </tspan>
          <tspan x="-21" y="22">
            済み
          </tspan>
        </text>
      </g>
    </svg>
  );
};

export default ApplicationBtnCenterApplied;
